export const LABEL_FIRST_INPUT_DELAY = 'first-input-delay';
export const LABEL_TIME_TO_FIRST_BYTE = 'time-to-first-byte';
export const LABEL_TIME_TO_INTERACTIVE = 'time-to-interactive';
export const LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
export const LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT = 'largest-contentful-paint';
export const LABEL_CUMULATIVE_LAYOUT_SHIFT = 'cumulative-layout-shift';
export const LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT = 'first-meaningful-paint';
export const LABEL_RESOURCE_DOWNLOAD_TIME_SUM = 'resource-download-time-sum';
export const LABEL_CAAS_SPI_METHOD_EXECUTION = 'caas-spi-execution';
export const LABEL_ALGOLIA_SEARCH_TIMING = 'algolia-search';
export const LABEL_COMPONENT_ERROR_BOUNDARY = 'component-error-boundary';
export const LABEL_GENERIC_TASK = 'generic-task';